var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function ArrowUndoIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0033 10C18.2107 10 20 11.7903 20 14C20 16.2076 18.2077 18 16.0033 18H4C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20H16.0033C19.3123 20 22 17.3121 22 14C22 10.686 19.3155 8 16.0033 8H6.41421L8.70711 5.70711C9.09763 5.31658 9.09763 4.68342 8.70711 4.29289C8.31658 3.90237 7.68342 3.90237 7.29289 4.29289L3.29289 8.29289C2.90237 8.68342 2.90237 9.31658 3.29289 9.70711L7.29289 13.7071C7.68342 14.0976 8.31658 14.0976 8.70711 13.7071C9.09763 13.3166 9.09763 12.6834 8.70711 12.2929L6.41421 10H16.0033Z", fill: "" })));
}
export var ArrowUndoIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: ArrowUndoIconInner }, props))); };
//# sourceMappingURL=ArrowUndoIcon.js.map